const wallet = {
  wallet: {
    calculateRollover: 'Calculate Rollover',
    setNewWallet: 'Manual Bonus Wallet',
    depositId: 'Deposit ID',
    depositAmount: 'Deposit Amount',
    coefficient: 'Coefficient',
    grantedBy: 'Granted By',
    bonusBalance: 'Bonus Balance',
    totalRolloverAmount: 'Total Rollover Amount',
    rolloverAmountCoefficientHelper:
      'Please enter a rollover coefficient.  This value will be multiplied by the bonus amount.  The result will be the total rollover amount for this bonus in the respective player currency.',
    rolloverAmountTotalHelper:
      'Please enter a total rollover amount.  This value will be the final total rollover amount required to release this bonus in the respective player currency',
    inTotalRolloverAmount: 'in total rollover amount',
    createdAt: 'Date Granted',
    wallet: 'Bonus Wallet',
    manualMaxWin: 'Max Win',
    manualBonus: 'Manual Bonus',
    walletStatusType: {
      ACTIVE: 'Active',
      CANCELED: 'Canceled',
      EXPIRED: 'Expired',
      USEDUP: 'Used Up',
      RELEASED: 'Released',
    },
    syncBonus: 'Sync Bonus',
    syncBetsoftBonusMessage: 'The Betsoft Bonus was sync correctly',
  },
}

export default wallet
